export default {
  reviewStatistics: "dashboard/REVIEW_CU/getReviewStatistics",
  dateStatistics: "dashboard/REVIEW_CU/getDateStatistics",
  reviewLogs: "dashboard/reviewLogs",
  cueueApplications: (endpoint, query = {}) =>
    `dashboard/cueueApplications/${endpoint}?${preparequery(query)}`,
  getApplicationComments: (query) =>
    `dashboard/applicationComments?${preparequery(query)}`,
};

const preparequery = (query) => {
  const queryArr = [];
  for (const [key, value] of Object.entries(query)) {
    queryArr.push(`${key}=${value}`);
  }
  return queryArr.join("&");
};
